// ===== RESPONSABLE FORMATION =====
import DashboardCollabRH from "../app/modules/adminrh/Dashboard/DashboardJS/DashboardCollabRH";
import CampagneFormModal from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneFormModal";
import CatalogueManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/CatalogueManagement";
import FormationManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/FormationManagement";
import ParamDomainesThemes from "../app/modules/Formation/ResponsableFormation/RessourcesJs/ParamDomainesThemes";
import SalleManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/SalleManagement";
import ConsolidationDemandes from "../app/modules/Formation/ResponsableFormation/RessourcesJs/ConsolidationDemandes";
import DemanderFormationRf from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/DemanderFormationRf";
import TraitementDemandesRf from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/TraitementDemandesRf";
import FournisseurManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/FournisseurManagement";
import ConsultantManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/ConsultantManagement";
import ModuleCleManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/moduleCle/ModuleCleManagement";
import EventManagement from "../app/modules/Formation/ResponsableFormation/RessourcesJs/events/EventManagement";

// ===== MANAGER =====
import DemanderFormationManager from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/DemanderFormationManager";
import TraitementDemandesManager from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/TraitementDemandesManager";

// ===== APPRENANT =====
import DemanderFormation from "../app/modules/Formation/ResponsableFormation/RessourcesJs/demandes/DemanderFormation";
import CampagneManagement
    from "../app/modules/Formation/ResponsableFormation/RessourcesJs/campagnes/CampagneManagement";
import EvaluationsManagement from "../app/modules/Evaluations/EvaluationsManagement";

export const FormationRoutes  = [

    // ===== RESPONSABLE DASHBOARD =====
    { path: "/formation/responsable/dashboard", element: <DashboardCollabRH /> },

    // ===== CAMPAGNES =====
    { path: "/formation/responsable/campagnes", element: <CampagneManagement /> },
    { path: "/formation/responsable/campagnes/add", element: <CampagneFormModal /> },
    { path: "/formation/responsable/campagnes/:id/edit", element: <CampagneFormModal /> },

    // ===== RESSOURCES =====
    { path: "/formation/responsable/catalogues", element: <CatalogueManagement /> },
    { path: "/formation/responsable/formations", element: <FormationManagement /> },
    { path: "/formation/responsable/domaines-themes", element: <ParamDomainesThemes /> },
    { path: "/formation/responsable/salles", element: <SalleManagement /> },
    { path: "/formation/responsable/fournisseurs", element: <FournisseurManagement /> },
    { path: "/formation/responsable/consultants", element: <ConsultantManagement /> },
    { path: "/formation/responsable/modules", element: <ModuleCleManagement /> },
    { path: "/formation/responsable/evenements", element: <EventManagement /> },
    { path: "/formation/responsable/evaluations", element: <EvaluationsManagement /> },

    // ===== DEMANDES RESPONSABLE =====
    { path: "/formation/responsable/consolidation", element: <ConsolidationDemandes /> },
    { path: "/formation/responsable/demande", element: <DemanderFormationRf /> },
    { path: "/formation/responsable/demande/traitement", element: <TraitementDemandesRf /> },

    // ===== MANAGER =====
    { path: "/formation/manager/demande", element: <DemanderFormationManager /> },
    { path: "/formation/manager/demande/traitement", element: <TraitementDemandesManager /> },

    // ===== APPRENANT =====
    { path: "/formation/apprenant/demande", element: <DemanderFormation /> }
];
